import React from "react";

import { useTheme, Statistics, IconPanel, Grid } from "@tiny/components";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import Global from "@tiny/icons/generated/Global";
import Destination from "@tiny/icons/generated/Destination";
import UserMinus from "@tiny/icons/generated/UserMinus";
import { useSuppressionStatistics } from "../../hooks/useSuppressionStatistics";

function AudienceStats() {
  const theme = useTheme();

  const { mdUp, lgUp } = useBreakpoints();

  const { globalSuppressedEmails, localSuppressedEmails, isLoading } =
    useSuppressionStatistics();

  return (
    <Grid container spacing={lgUp ? 5 : mdUp ? 4 : 2}>
      <Grid item xs={12} md={6}>
        <IconPanel
          icon={<Global />}
          color={theme.palette.primary.main}
          hasBorderRadius={mdUp}
        >
          <Statistics
            value={isLoading ? "-" : globalSuppressedEmails}
            title="Global suppression emails"
            info="Global suppression emails"
          />
        </IconPanel>
      </Grid>
      <Grid item xs={12} md={6}>
        <IconPanel
          icon={<Destination />}
          color={theme.palette.primary.main}
          hasBorderRadius={mdUp}
        >
          <Statistics
            value={isLoading ? "-" : localSuppressedEmails}
            title="Local suppression emails"
            info="Local suppression emails"
          />
        </IconPanel>
      </Grid>
    </Grid>
  );
}

export default AudienceStats;
